"use client";

import { useState } from 'react';
import { Link } from 'react-router-dom';
import contractImg1 from '../../assets/images/resources/contact-three-img-1.jpg';
import contractShape1 from '../../assets/images/shapes/contact-three-shape-1.png';
import '../../assets/css/contact.css';
// Define a list of services for the dropdown
const services = [
  "Choose a Option",
  "Type Of Service 01",
  "Type Of Service 02",
  "Type Of Service 03",
  "Type Of Service 04",
  "Type Of Service 05"
];

export default function ContactThree() {
  const [selectedService, setSelectedService] = useState(services[0]);
    // ✅ Add form state to track user input
    const [formData, setFormData] = useState({
      name: "",
      email: "",
      phone: "",
      subject: "",
      message: "",
    });
  
    const [errors, setErrors] = useState({}); // ✅ Store validation errors
    const [status, setStatus] = useState(null);
  
    // ✅ Handle input change
    const handleChange = (e) => {
      setFormData({ ...formData, [e.target.name]: e.target.value });
  
      // Clear errors when user starts typing
      setErrors({ ...errors, [e.target.name]: "" });
    };
  
    // ✅ Validate form before submitting
    const validateForm = () => {
      let newErrors = {};
      if (!formData.name.trim()) newErrors.name = "Name is required.";
      if (!formData.email.trim()) {
        newErrors.email = "Email is required.";
      } else if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
        newErrors.email = "Invalid email format.";
      }
      if (!formData.phone.trim()) {
        newErrors.phone = "Phone number is required.";
      } else if (!/^[6789]\d{9}$/.test(formData.phone)) {
        newErrors.phone = "Enter a valid 10-digit phone number.";
      }
      if (!formData.subject.trim()) newErrors.subject = "Subject is required.";
      if (!formData.message.trim()) newErrors.message = "Message is required.";
  
      setErrors(newErrors);
      return Object.keys(newErrors).length === 0; // ✅ If no errors, return true
    };
  
    // ✅ Handle form submission
    const handleSubmit = async (e) => {
      e.preventDefault();
     
      if (!validateForm()) return;
      try {
        const response = await fetch("https://tt.sanvima.net/sendemail.php", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        });
  
        const data = await response.text();
        console.log("Server Response:", data);
        if (data.includes("Data saved successfully")) {
          setStatus("Message sent successfully!"); // ✅ Set success message
          setFormData({ name: "", email: "", phone: "", subject: "", message: "" }); // ✅ Clear form fields
        } else {
          setStatus("Failed to send message."); // ✅ Handle errors
        }
      } catch (error) {
        console.error("Error:", error);
        setStatus("Failed to save data.");
      }
    };

    return (
      <>
        {/* Contact Three Start */}
        <section className="contact-three">
          <div className="container">
            <div className="row">
              <div className="col-xl-6 wow fadeInLeft" data-wow-delay="100ms">
                <div className="contact-three__left">
                  <div className="section-title text-left">
                    <div className="section-title__tagline-box">
                      <span className="section-title__tagline">Get in Touch</span>
                    </div>
                    <h2 className="section-title__title">
                    Got Questions <span>or Need Support?</span>
                    </h2>
                  </div>
                  <ul className="contact-three__points list-unstyled">
                    <li>
                      <p>
                      Our team is dedicated to delivering top-notch cybersecurity guidance and solutions tailored to your needs. Whether you’re an IT expert, a business leader, or new to the cybersecurity landscape, we’re here to assist you every step of the way. Feel free to reach out with any inquiries or for personalized support.
                      </p>
                    </li>
                  </ul>
                  <div className="footer-widget-two__social">
                     <Link to="https://www.linkedin.com/in/techtotalers-private-limited-020b0a248?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"><span className="icon-linkedin-in"></span></Link>
                  </div>
                </div>
              </div>
              <div className="col-xl-6 wow fadeInRight" data-wow-delay="300ms">
                <div className="contact-three__right">
                  <div className="contact-three__shape-1">
                    <img src={contractShape1} alt="" />
                  </div>
                  <h3 className="contact-three__right-title">Contact</h3>
                  <form className="contact-three__form" onSubmit={handleSubmit} noValidate>
                    <div className="row">
                      <div className="col-xl-6 col-lg-6 col-md-6">
                        <div className="contact-three__input-box">
                          <h4 className="contact-three__input-title">Name</h4>
                          <input
                            type="text"
                            name="name"
                            placeholder="Your Name"
                            required
                            value={formData.name}
                            onChange={handleChange}
                            
                          />
                          {errors.name && <p className="error-message">{errors.name}</p>}
                        </div>
                      </div>
                      <div className="col-xl-6 col-lg-6 col-md-6">
                        <div className="contact-three__input-box">
                          <h4 className="contact-three__input-title">Email</h4>
                          <input
                            type="email"
                            name="email"
                            placeholder="Your Email"
                            required
                            value={formData.email}
                            onChange={handleChange}
                          />
                          {errors.name && <p className="error-message">{errors.name}</p>}
                        </div>
                      </div>
                      <div className="col-xl-6 col-lg-6 col-md-6">
                        <div className="contact-three__input-box">
                          <h4 className="contact-three__input-title">Phone Number</h4>
                          <input
                            type="text"
                            name="phone"
                            placeholder="Your Phone Number"
                            required
                            value={formData.phone}
                            onChange={handleChange}
                          />
                          {errors.phone && <p className="error-message">{errors.phone}</p>}
                        </div>
                      </div>
                      <div className="col-xl-6 col-lg-6 col-md-6">
                        <div className="contact-three__input-box">
                          <h4 className="contact-three__input-title">Subject</h4>
                          <input
                            type="text"
                            name="subject"
                            placeholder="Subject"
                            required
                            value={formData.subject}
                            onChange={handleChange}
                            
                          />
                          {errors.subject && <p className="error-message">{errors.subject}</p>}
                        </div>
                      </div>
                      <div className="col-xl-12">
                        <h4 className="contact-three__input-title">Message</h4>
                        <div className="contact-three__input-box text-message-box">
                          <textarea
                            name="message"
                            placeholder="Message here.."
                            required
                            value={formData.message}
                            onChange={handleChange}
                            
                          ></textarea>
                          {errors.message && <p className="error-message">{errors.message}</p>}
                        </div>
                        <div className="contact-three__btn-box-two">
                          <button type="submit" className="thm-btn-two contact-three__btn-two">
                            Submit Now<span className="icon-dubble-arrow-right"></span>
                          </button>
                          {status && (
    <p className={`status-message ${status.includes("success") ? "success" : "error"}`}>
      {status}
    </p>
  )}
                        </div>
                      </div>
                    </div>
                  </form>
                  <div className="result"></div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Contact Three End */}
      </>
    );
  }